// extracted by mini-css-extract-plugin
export default {"Box":"iteration-renderer-module__Box--nWpdz","Label":"iteration-renderer-module__Label--NujJL"};